import React from "react";
import { Site, IQWatchDevice } from "../types";
// DeviceListPanel import removed - focusing on IQWatch devices only
import IQWatchDeviceList from "./IQWatchDeviceList.tsx";

interface CombinedDevicePanelProps {
  site: Site | null;
  orgId?: string;
  // Edge device props removed - focusing on IQWatch devices only
  onEditIQWatchDevice?: (device: IQWatchDevice) => void;
  onDeleteIQWatchDevice?: (device: IQWatchDevice) => void;
  onAddIQWatchDevice?: () => void;
}

const CombinedDevicePanel: React.FC<CombinedDevicePanelProps> = ({
  site,
  orgId,
  // Edge device props removed - focusing on IQWatch devices only
  onEditIQWatchDevice,
  onDeleteIQWatchDevice,
  onAddIQWatchDevice,
}) => {
  // Edge device detection removed - focusing on IQWatch devices only

  return (
    <div className="flex-1 flex flex-col">
      {/* Edge Device tabs removed - focusing on IQWatch devices only */}

      {/* IQWatch 设备列表内容 */}
      <div className="flex-1 overflow-auto">
        <IQWatchDeviceList
          site={site}
          orgId={orgId}
          onEditDevice={onEditIQWatchDevice}
          onDeleteDevice={onDeleteIQWatchDevice}
          onAddDevice={onAddIQWatchDevice}
        />
      </div>
    </div>
  );
};

export default CombinedDevicePanel;
